import { SparkleIcon } from '@/src/assets/icons'
import { useEmberStore } from '@/src/features/Ember/infrastructure/useEmberStore'
import { useIsLegacyInsightsNavEnabled } from '@/src/shared/feature-flag/feature-flag.hooks'
import { useNavbarCollapsedStore } from '@/src/shared/infrastructure/useNavbarCollapsedStore'
import { useInsightsStore } from '@/src/widgets/InsightsVideoCta/useInsightsStore'
import { FlexRow } from '@components'
import { useTranslation } from 'react-i18next'
import { LuLightbulb } from 'react-icons/lu'
import { BaseText } from '../BaseText'
import { BaseButton } from '../buttons/BaseButton'

export function EmberTopBarArea() {
  const { t } = useTranslation()
  const emberStore = useEmberStore()
  const navbarCollapsedStore = useNavbarCollapsedStore()
  const { removeInsight } = useInsightsStore()
  const isLegacyInsightsNavEnabled = useIsLegacyInsightsNavEnabled()

  const openSidebar = (tabValue: string) => {
    emberStore.setCurrentTabValue(tabValue)
    emberStore.openSidebar()
    navbarCollapsedStore.setCollapsed(true)
  }

  const closeEmberSidebar = () => {
    emberStore.toggleSidebar()
    removeInsight()
    if (!navbarCollapsedStore.userCollapsedIt) {
      navbarCollapsedStore.setCollapsed(false)
    }
  }

  const openInsights = () => {
    if (emberStore.isSidebarShowing && emberStore.currentTabValue === 'insights') {
      closeEmberSidebar()
    } else {
      openSidebar('insights')
    }
  }

  const openChat = () => {
    if (emberStore.isSidebarShowing && emberStore.currentTabValue === 'chat') {
      closeEmberSidebar()
    } else {
      openSidebar('chat')
    }
  }

  return (
    <FlexRow cursor={'pointer'} alignItems={'center'}>
      <BaseButton
        onClick={openChat}
        iconLeft={<SparkleIcon width={'14px'} height={'14px'} />}
        colorScheme='yellow'
        mr={'8px'}
        id='ember-button'
      >
        <BaseText fontWeight={100}>{t('emberChat.top_bar_area.assistant')}</BaseText>
      </BaseButton>
      {isLegacyInsightsNavEnabled && (
        <BaseButton
          onClick={openInsights}
          iconLeft={<LuLightbulb fill='#000' width={'14px'} height={'14px'} />}
          variant='secondary'
          borderWidth={'0px'}
          id='insights-button'
        >
          <BaseText fontWeight={100}>{t('emberChat.top_bar_area.insights')}</BaseText>
        </BaseButton>
      )}
    </FlexRow>
  )
}
